import { Component, OnInit } from '@angular/core';
import { CurrentService } from '../../services/current.service';
import { MODAL, ModalService } from 'src/app/services/modal.service';
import { UserService } from 'src/app/services/user.service';
import { DatasService } from 'src/app/services/datas.service';

@Component({
  selector: 'ng-hbm-bdi-design',
  templateUrl: './design.component.html',
  host: { 'class': 'container' }
})
export class DesignComponent implements OnInit {

  currentTabId: number = 1;
  customerName: string;

  constructor(private modalService: ModalService,
    private customer: UserService,
    public current: CurrentService,
    public datas: DatasService) { }

  ngOnInit(): void {
    this.current.reset();
    if (this.customer.userDatas) {
      if (this.customer.userDatas.otherAccount) {
        this.customerName = this.customer.userDatas.otherAccount.completeName;
      }
    }
  }

  nextTab() {
    this.currentTabId++;
  }

  goProjects() {
    this.modalService.display(MODAL.PROJECTS, { customerId: this.customer.userDatas.hbmId });
  }

  isProjectButtonVisible(): boolean {
    if (this.customer.isLogged) {
      if (this.customer.userDatas.hbmId != null) {
        return true;
      }
    }
    return false;
  }
}
